import { useQuery } from "@apollo/client";
import { loader } from "graphql.macro";
import { add, fraction, unit } from "mathjs";
import React from "react";
import db from "../util/storage";
import Loading from "../components/Loaders/Loading";
import Card from "../components/RecipeView/Card";

const GET_MEAL_PLAN = loader("../queries/meal-plan.graphql");

const processData = (output) => {
	const groups = new Map();

	for (let recipe of output) {
		const ingredients = recipe.recipeIngredientGroups
			.flatMap((g) => g.recipeIngredients)
			.map((i) => ({ ...i, ...i.ingredient }));

		for (let ingredient of ingredients) {
			let { kind, measurement, pluralName, quantity } = ingredient;

			let parsedQuantity;
			try {
				parsedQuantity = new fraction(quantity).valueOf();
			} catch {
				parsedQuantity = 1;
			}

			let amt;
			try {
				amt = new unit(parsedQuantity, measurement);
			} catch (e) {
				amt = new unit(parsedQuantity);
			}

			if (groups.has(kind)) {
				const map = groups.get(kind);
				const existing = map.get(pluralName);
				if (existing) {
					let sum;
					try {
						sum = add(existing, amt);
					} catch {
						sum = existing;
					}

					map.set(pluralName, sum);
				} else {
					map.set(pluralName, amt);
				}
			} else {
				groups.set(kind, new Map([[pluralName, amt]]));
			}
		}
	}

	return groups;
};

export default function MealPlan() {
	const recipeIds = db.getAllItems();

	let { loading, error, data } = useQuery(GET_MEAL_PLAN, {
		variables: { ids: recipeIds },
	});

	if (loading) {
		return <Loading />;
	}

	if (error) {
		return `Error! ${error.message}`;
	}

	// Map the data
	data = data?.search?.hits.map(({ _source }) => ({ ..._source }));

	const mealPlan = processData(data);

	return (
		<div className="container">
			<section className="section">
				<h3 className="title is-3">Meal Plan</h3>

				<div className="columns meal-plan" style={{ overflowX: "auto" }}>
					{data.map((recipe, i) => (
						<div className="column is-one-fifth" key={i}>
							<Card recipe={recipe} />
							{/* <div className="column is-1">
								<button
									className="delete"
									type="button"
									onClick={() => removeTag(recipe)}></button>
							</div> */}
						</div>
					))}
				</div>
			</section>

			<section className="section">
				<h3 className="title is-3">Ingredients</h3>

				<div style={{ columns: "5 300px", columnGap: "2rem" }}>
					{[...mealPlan.entries()].map(([name, ingredients], i) => {
						return (
							<div key={i}>
								<h4 className="title is-5">{name}</h4>
								<ul style={{ marginTop: 0 }}>
									{[...ingredients.entries()].map(([ingredient, amount], i) => {
										return (
											<li key={i}>
												{new fraction(amount?.toNumber()).toFraction(true) ||
													""}
												&nbsp;
												{amount.formatUnits() ? (
													<>{amount.formatUnits()}&nbsp;</>
												) : (
													""
												)}
												{ingredient}
											</li>
										);
									})}
								</ul>
								<br />
							</div>
						);
					})}
				</div>
			</section>
		</div>
	);
}
